import React from 'react';
import FailureMechanismImg from "../../../images/KOC/failureMechanism.png"
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';

function FailureMechanism() {
    return (
         <div className="chart-view">
             <Grid container spacing={3}>
                <Grid item xs={8}>
                  <Card className="px-20">
                    <img src={FailureMechanismImg}/>
                  </Card>
                </Grid>
              </Grid>
         </div>
        
    )
}

export default FailureMechanism;